// import { paymentMethods } from "../mockapi/getPaymentMethods";
// import { PaymentMethod } from "../models/PaymentMethod";
// import getSystemLanguage from "./getSystemLanguage";

const getInstructionByPaymentProvider = (code: string | undefined): string => {
  // const userLanguage = getSystemLanguage();
  // const message = paymentMethods.find((item) => item.payItemId === code);
  // const element = message?.instructions.find((el) => el.lang === userLanguage);

  return "If you didn’t receive an SMS, dial *126# to confirm the payment.";
};

export default getInstructionByPaymentProvider;
